import { IonCheckbox, IonPopover } from '@ionic/react'
import React, { useState } from 'react'
import './index.scss'

interface IModalProps {
  isSave: boolean;
  onChange: (checked: boolean) => void;
}

const ResultAlert: React.FC<IModalProps> = (props: IModalProps) => {
  const { isSave, onChange } = props
  const [event, setEvent] = useState<any>(undefined)
  return (
    <div className='save-cookie-info-bar'>
      <IonCheckbox
        checked={isSave} data-cypid='saveCookieInfoCheckbox' onIonChange={({ detail }) => onChange(detail.checked)}
      >
      </IonCheckbox>
      {i18n.t('mkt.login.saveCookie')}
      <span className='link-btn' data-cypid='saveCookieInfoTipsShow' onClick={e => setEvent(e)}>{i18n.t('mkt.login.detail')}</span>
      <IonPopover
        cssClass='cart-tips-popover'
        event={event}
        isOpen={!!event}
        onDidDismiss={() =>
          setEvent(undefined)}
      >
        <p>{i18n.t('mkt.login.saveCookieTips')}</p>
        <span
          data-cypid='saveCookieInfoTipsHide'
          onClick={(e: any) => {
            e.persist()
            setEvent(undefined)
          }}
        >
          {i18n.t('newCart.know')}
        </span>
      </IonPopover>
    </div>
  )
}

export default ResultAlert
